import styled from 'styled-components/macro';
import { TYPOGRAPHY } from 'styleguide';

const PositionMsg = styled.div`
  position: relative;
  padding-right: 20px;
  ${TYPOGRAPHY.body}
  overflow-wrap: break-word;
  word-break: break-word;
`;

export default PositionMsg;
